import React from "react";
import ReportItem from "./ReportItem";
import {DriveReport} from "./ReportsView";

type Props = {
    reports: [DriveReport],
    deleteReport?: any,
    getReport?: any,
    reportPending: any,
    language: string,
    getReportPending: any
}
const ReportsList: (props: Props) => React.JSX.Element = (props: Props): React.JSX.Element => {
    const { reports, deleteReport, getReport, reportPending, language, getReportPending } = props;
    return (
        <>
            <div id="inb-c-main-reports" className="inb-c-listing off-canvas-content" data-off-canvas-content="" key="inb-c-main-resources">
            {reports.map((report:DriveReport): React.JSX.Element => {
                return (
                    <>
                    <ReportItem
                        report={report}
                        deleteReport={deleteReport}
                        getReport={getReport}
                        index={report.id}
                        deleteReportPending={reportPending}
                        getReportPending={getReportPending}
                        language={language}
                    />
                </>
                );
            })}
            </div>
        </>
    );
}

export default ReportsList;